<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">Update Merchandise Category</div>
    </div>
    <div class="white-wrapper" style="zoom: 0.9">
      <form class="row">
        <div class="col-lg-3 col-xl-3 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="m_cat_name"
                type="text"
                name="m_cat_name"
                id="m_cat_name"
              />
              <label>Category Name</label>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-xl-3 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">Active</label>
            <b-form-checkbox
              unchecked-value="N"
              value="Y"
              v-model="cat_is_active"
              name="check-button"
              switch
            ></b-form-checkbox>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="merchandise-category"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      btenable: false,
      m_cat_name: "",
      m_cat_id: null,
      cat_is_active: "Y",
      submitted: false,
    };
  },
  mounted() {},
  beforeMount() {
    const { m_cat_id } = this.$route.query;
    if (m_cat_id) {
      this.m_cat_id = m_cat_id;
      this.getItemsDetails(m_cat_id);
    }
  },
  methods: {
    getItemsDetails(item_id) {
      let loader = this.$loading.show();
      let payload = {
        m_cat_id: item_id,
      };
      MasterService.GetSingleMerchandiseCategory(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records && data.Records.length > 0) {
            const { m_cat_name, m_cat_id, cat_is_active } = data.Records[0];
            this.m_cat_name = m_cat_name;
            this.m_cat_id = m_cat_id;
            this.cat_is_active = cat_is_active;
          } else {
            this.$toasted.show(data.message || "Unable to fetch data");
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    OnFinalSubmit: function (redirect) {
      this.submitted = true;
      if (!this.m_cat_name) {
        return this.$toasted.show("Please Enter Category Name");
      } else {
        let loader = this.$loading.show();
        let payload = {
          m_cat_id: this.m_cat_id,
          m_cat_name: this.m_cat_name,
          cat_is_active: this.cat_is_active || "Y",
        };
        MasterService.UpdateMerchandiseCategory(payload)
          .then((response) => {
            this.btenable = false;
            const { data } = response;
            if (data && data.status) {
              this.resetForm();
              if (redirect) {
                this.$router.push({
                  path: "merchandise-category",
                });
              }
              this.submitted = false;
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            loader.hide();
          });
      }
    },
    resetForm: function () {
      this.m_cat_id = null;
      this.m_cat_name = "";
      this.cat_is_active = "Y";
      this.btenable = false;
      this.submitted = false;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/MechandiseComponents/UpdateMerchandiseCategory.vue